import React from "react"
import { FormContainer, InputField, StandardModal, DatePicker } from "uikit"
import { Grid, Form } from "semantic-ui-react"

const AddDepreciationFormModal = ({
  data: {
    fields: { description, basis, start_date, recovery_period },
    onSubmit,
    isPending,
    hasError = false
  },
  isEditing,
  cancel
}) => {
  return (
    <StandardModal defaultOpen={true} closeOnDimmerClick={false}>
      <StandardModal.Header
        header={`${isEditing ? "Edit" : "Add"} Property Depreciation`}
      />
      <StandardModal.Content>
        <Form
          error={hasError}
          loading={isPending}
          className="AddModal__Form"
          onSubmit={onSubmit}
        >
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <InputField
                  field={description}
                  label="Description"
                  className="AddModal__FormField"
                />
                <InputField
                  field={basis}
                  label="Basis"
                  className="AddModal__FormField"
                />
                <InputField
                  field={start_date}
                  label="Date property/improvement placed in service"
                  control={DatePicker}
                  className="AddModal__FormField"
                />
                <InputField
                  field={recovery_period}
                  label="Duration of service for depreciation"
                  className="AddModal__FormField"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <button type="submit" style={{ display: "none" }} />
        </Form>
      </StandardModal.Content>
      <StandardModal.Actions
        submitLabel={`${isEditing ? "Edit" : "Add"} Depreciation`}
        cancelLabel="Cancel"
        onSubmit={onSubmit}
        onCancel={cancel}
        cancelCanDisabled={false}
        loading={isPending || hasError}
      />
    </StandardModal>
  )
}

const DepreciationFormContainer = FormContainer(
  {
    description: {
      type: "string"
    },
    basis: {
      type: "unit"
    },
    start_date: {
      type: "date",
      maxValue: new Date()
    },
    recovery_period: {
      type: "decimal",
      defaultValue: 27.5,
      minValue: 0,
      maxValue: 40
    }
  },
  ({ fields }, ...form) => {
    const { start_date, recovery_period } = fields
    if (
      start_date.isEmpty ||
      start_date.hasError ||
      start_date.value.length < 10
    ) {
      return
    }
    const start = start_date.value.split("/")
    const recoveryEnds = new Date(
      parseFloat(start[2]) + parseFloat(recovery_period.value),
      parseFloat(start[0]) - 1,
      parseFloat(start[1])
    )
    if (recoveryEnds < new Date()) {
      return {
        fields: {
          recovery_period: `Recovery date should be in the future.`
        }
      }
    } else {
      return {
        fields: {
          recovery_period: null
        }
      }
    }
  }
)(AddDepreciationFormModal)

export const AddDepreciationModal = ({
  isEditing,
  depreciation,
  ...formProps
}) => {
  const values = {}
  if (isEditing) {
    const keys = Object.keys(depreciation.fields)
    keys.forEach(key => (values[key] = depreciation.fields[key].value))
  }
  return <DepreciationFormContainer {...{ isEditing, values, ...formProps }} />
}
